<template>
  <div :id="'J_upload_id_' + keyNo" :class="[bem(), className]">
    <ul :class="bem('list')" class="drag-wrap">
      <draggable v-model="imgList" filter=".image-add-btn"  delay="200" :distance="10" forceFallback="true" :disabled="disableDrag" group="drag-wrap" animation="300" @end="onEnd">
        <li
          v-for="(img, idx) in imgList"
          :key="img.index"
          :style="imgStyle"
          :class="['image-item', 'drag-image-item']"
          name="file"
          @click="onShowBigImg(idx)"
        >
          <v-pending v-if="img.isLoading" />
          <div class="img"><img class="upload-img" v-show="img.fullThumbUrl" :src="img.fullThumbUrl" /></div>
          <i v-show="img.fullThumbUrl" class="delete J_delete" @click.stop="onClickDeleteImg(img.index)"></i>
        </li>
      <slot v-if="$slots.imgAddBtn && showUploadAdd" name="imgAddBtn" />
      <li v-else v-show="showUploadAdd" :style="imgStyle" class="image-item image-add-btn" name="file" @click="onClickUpload"></li>
    </draggable>
    </ul>
    <div
      :id="keyNo ? 'J_uploader_' + keyNo : 'J_uploader'"
      :class="['uploader', keyNo ? 'J_uploader_' + keyNo : 'J_uploader']"
    ></div>
    <!-- <p :class="bem('prompt')">每张图片不超过{{fileSize}}M，可提交{{min}}-{{max}}张，支持jpg、jpeg、gif、bmp、png格式</p> -->
    <v-image-preview
      :show="showBigImg"
      :images="bigImages"
      :startPosition="startPosition"
      :onClose="onHideBigImg"
    ></v-image-preview>
  </div>
</template>

<script>
import create from '../create'
import app from 'utils/app'
import env from 'utils/clientEnv'
import ImagePreview from '../image-preview'
import { debounce } from '@/utils/common'
import draggable from 'vuedraggable'
export default create({
  name: 'image-upload',
  components: {
    ImagePreview,
    draggable
  },
  props: {
    className: [String, Object, Array],
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 5
    },
    // 单位字节数
    fileSize: {
      type: Number,
      default: -1
    },
    url: {
      type: String,
      required: true
    },
    keyNo: {
      type: String,
      default: ''
    },
    fileVal: {
      type: String,
      default: 'file'
    },
    maxSize: {
      type: Number,
      default: -1
    },
    //每行图片数量
    picNumInLine:{
      type: Number,
      default: 4
    },
    disableDrag:{
      type:Boolean,
      default:true
    }
  },

  data() {
    return {
      pageInit: false,
      width: 10,
      height: 10,
      imgList: [],
      showBigImg: false,
      startPosition: 0,
      bigImages: [],
      uploadDom: ''
    }
  },
  mounted() {
    if (!this.pageInit) {
      this.setSize()
      this.pageInit = true
      this.$nextTick(() => {
        this.uploadImage()
      })
    }
    window.addEventListener(
      'resize',
      debounce(() => {
        this.setSize()
      })
    )
  },
  computed: {
    showUploadAdd() {
      return this.imgList.length < this.max
    },
    imgStyle() {
      return 'width: ' + this.width + 'px;height: ' + this.height + 'px'
    }
  },

  methods: {
    setSize() {
      this.uploadDom = document.getElementById('J_upload_id_' + this.keyNo)
      // let maxLen = this.max - this.min + 1
      let maxLen = this.picNumInLine
      let wrapWidth = this.uploadDom.getElementsByClassName('v-image-upload__list')[0].getBoundingClientRect().width
      let addBtn = this.uploadDom.getElementsByClassName('image-add-btn')[0]
      let marginValue = window.getComputedStyle(addBtn, null).marginRight
      let index = marginValue.indexOf('px')
      marginValue = index != -1 ? marginValue.substr(0, index) : marginValue
      let itemWidth = Math.floor((wrapWidth - (maxLen + 1) * marginValue) / maxLen)
      let imgMaxSize = wrapWidth / maxLen
      itemWidth = itemWidth > imgMaxSize ? imgMaxSize : itemWidth
      this.width = itemWidth
      this.height = itemWidth
    },
    // 显示上传区域的大图
    onShowBigImg(index) {
      // 如果是app，调用native接口
      if (!app.remarkShowBigImage(this.bigImages, index)) {
        this.startPosition = index
        this.showBigImg = true
      }
    },
    // 隐藏上传区域的大图
    onHideBigImg() {
      this.showBigImg = false
    },
    // 删除已上传图片
    onClickDeleteImg(index) {
      this.imgList.splice(
        this.imgList.findIndex(item => {
          return item.index === index
        }),
        1
      )
      this.reloadBigImages()
      // 图片删除抛事件给父页面处理
      this.$emit('uploadRefresh')
    },
    onClickUpload() {
      // 判断是否有图片正在上传
      if (document.getElementsByClassName('loading').length > 0) {
        this.$toast('图片上传中，请稍候')
        return
      }

      if (env.isVivoApp && env.androidLevel <= 5.1) {
        return this.$toast('您当前安卓版本过低，上传不了图片，请升级到更高版本或不填此项申请信息')
      }
      let uploadInput = this.uploadDom.getElementsByClassName('webuploader-element-invisible')[0]
      uploadInput && uploadInput.click()
      // 点击上传图片按钮，用户外层埋点处理
      this.$emit('addImgClick')
    },
    getData() {
      return this.imgList
    },
    async uploadImage() {
      let fileType = ['jpg', 'jpeg', 'png', 'gif', 'bmp']
      let imgIndex = 0
      let uploader = window.WebUploader.create({
        // 文件接收服务端。
        server: this.url,
        // 选择文件的按钮，内部根据当前运行是创建，可能是input元素，也可能是flash.
        pick: {
          id: this.keyNo ? '.J_uploader_' + this.keyNo : '.J_uploader',
          multiple: false
        },
        accept: {
          title: 'Images',
          extensions: fileType.join(','),
          mimeTypes: 'image/*'
        },
        // fileNumLimit: 3,
        // 不压缩图片
        compress: false,
        // 可上传重复的文件
        duplicate: true,
        // 文件字段名称
        fileVal: this.fileVal
      })
        .on('beforeFileQueued', file => {
          // 没有后缀名也不能上传
          if (!file.ext || fileType.indexOf(file.ext.toLowerCase()) === -1) {
            this.$toast('文件格式错误')
            return false
          } else if (file.size > this.fileSize && this.fileSize >= 0) {
            this.$toast(`每张图片大小不能超过${this.fileSize / (1024 * 1024)}M`)
            return false
          }
        })
        .on('fileQueued', async () => {
          uploader.upload()
        })
        .on('uploadBeforeSend', (file, data) => {
          data.index = imgIndex
          data.photoIndex = imgIndex
          file.index = imgIndex
          this.imgList.unshift({
            index: imgIndex,
            isLoading: true
          })
          imgIndex++
          this.$emit('beginUpload')
        })
        .on('uploadSuccess', this.uploadSuccess)
        .on('uploadError', () => {
          this.imgList.shift()
          this.$toast('图片上传出错，请重新上传')
        })
    },
    uploadSuccess(file, response) {
      let data = response.data
      let idx = 0
      if (data) {
        idx = this.imgList.findIndex(item => {
          return item.index === data.photoIndex || data.index
        })
      } else if (file.blocks && file.blocks.length && file.blocks[0]) {
        idx = file.blocks[0].index
      }
      if (idx === -1) {
        idx = 0
      }
      if (response.code === 0) {
        let target = this.imgList[idx]
        target.isLoading = false
        target.resData = data
        target.absThumbUrl = data.thumbnailPic
        target.absOriUrl = data.bigPic
        target.fullBigUrl = data.absoluteBigPic
        target.fullThumbUrl = data.absoluteThumbnailPic || data.originUrl
        target.photoIndex = data.photoIndex || data.index
        target.prefix = data.index
        target.sizes = data.sizes
        target.suffix = data.suffix
        this.$set(this.imgList, idx, target)
        this.reloadBigImages()
        // 上传成功抛事件给父页面处理
        this.$emit('uploadRefresh')
      } else {
        this.imgList.shift()
        this.$toast({
          duration: 3000, // 持续展示 toast
          message: data || response.msg || response.message
        })
      }
    },
    reloadBigImages() {
      let list = []
      this.imgList.forEach(item => {
        list.push(item.fullBigUrl || item.fullThumbUrl)
      })
      this.bigImages = list
    },
    onEnd(){
      this.$emit('uploadRefresh')
    }
  }
})
</script>

<style scoped lang="scss" src="./index.scss"></style>
